<template>
    <div id="app" :class="classe" :style="coresTema" @click="dispatchEventClosePopups">
        <head>
            <title>{{$vistra.documentTitle}}</title>
        </head>
        <div id="area-de-popups"></div>
        <router-view class="dx-theme-background-color page"></router-view>
    </div>
</template>

<script>
    import traducaoGeral from "./localization/vistra.geral.json";
    import traducaoPaises from "./localization/vistra.paises.json";
    import traducaoMenu from "./localization/vistra.menu.json";
    import { currentTheme, refreshTheme } from "devextreme/viz/themes";
    import { mapGetters, mapMutations, mapActions } from 'vuex';
    import { locale } from 'devextreme/localization'
    import updateMixin from './mixins/update.js'
    import StatusSignalR from './views/StatusSignalR.vue'

    let EventClosePopups = null;


    const EVENTS = ['online', 'offline', 'load']
    
    export default {
        mixins: [updateMixin],
        components: {
			    StatusSignalR,
        },
        data() {
            return {
                // themes: _themes,
                carregouEmpresas: false,
                currentTheme1: currentTheme,
                refreshTheme1: refreshTheme,
                documentTitle: "",
                verificaCores: 0,
            };
        },
        computed: {
            ...mapGetters(['msgSistema', 'tema', 'isLoggedIn', 'sistema', 'onPainelMudouTema', 'idEmpresa', 'signalRStatus', 'token', 'usuario', 'tokenExpiration', 'empresas']),
            classe() {
                let temaClaroIntegracao = (this.$route.path == '/go' && !this.$route.query?.dark)
                let classe = ((this.tema === "tema-dark" && !(!this.$route.name && this.$route.fullPath == '/') && !temaClaroIntegracao)
                    || ["login", "resetarSenha", "login_expirou"].includes(this.$route.name))
                    ? this.$vistra.classeModoEscuro() 
                    : "";
                
                let pageBody = document.querySelector('.page-body')
                classe == this.$vistra.classeModoEscuro()
                    ? pageBody.classList.add(this.$vistra.classeModoEscuro())
                    : pageBody.classList.remove(this.$vistra.classeModoEscuro());
                    
                return classe
            },
            coresTema() {
                this.verificaCores;
                return {
                    "--tema-cor-texto": this.$vistra.Estilos.corTexto(),
                    "--tema-cor-principal": this.$vistra.Estilos.corTema(),
                    "--tema-cor-fundo": this.$vistra.Estilos.corFundo(),
                    "--tema-cor-fundo-l2": this.$vistra.pSBC(0.02, this.$vistra.Estilos.corFundo(), false, true), // 3% mais claro
                    "--tema-cor-fundo-l5": this.$vistra.pSBC(0.05, this.$vistra.Estilos.corFundo(), false, true), // 5% mais claro
                    "--tema-cor-fundo-l10": this.$vistra.pSBC(0.1, this.$vistra.Estilos.corFundo(), false, true), // 10% mais claro
                    "--tema-cor-fundo-d5": this.$vistra.pSBC(-0.05, this.$vistra.Estilos.corFundo(), false, true), // 5% mais escuro
                    "--tema-cor-fundo-d10": this.$vistra.pSBC(-0.1, this.$vistra.Estilos.corFundo(), false, true), // 10% mais escuro
                    "--tema-cor-borda": this.$vistra.Estilos.corBorda(),
                    "--tema-cor-selecao": this.$vistra.Estilos.corDoFundoSelecao(),
                    "--altura-barra-superior": "85px",
                    "--altura-barra-interna": "53px"
                }
            },
        },
        watch: {
            tokenExpiration: {
                immediate: true,
                handler(newVal) {
                    if (this.renewTokenTimeout)
                        clearInterval(this.renewTokenTimeout)
                    if (newVal) {
                        let tempo = Math.max(this.$vistra.addMinutes(-1, new Date(newVal)) - new Date(), 0)
                        if (window.isDebug)
                            console.time(`Próxima renovação de token às ${this.$vistra.formatDate(this.$vistra.addSeconds(tempo / 1000), 'HH:mm:ss')}`)
                        this.renewTokenTimeout = setTimeout(() => {
                            if (this.$route.query.hasOwnProperty('widget')) {
                                console.show('widget não renova token')
                                return
                            }
                            if (this.isLoggedIn)
                                this.$vistra.refreshToken()
                        }, tempo)
                    }
                }
            },
            carregouTema() {
                this.fazVerificacaoCores()
            },
            onPainelMudouTema() {
                this.fazVerificacaoCores()
            },
            tema: {                
                immediate: true,
                handler(newVal, oldVal) { 
                    if (newVal === "tema-dark")
                        currentTheme("material.blue.dark");
                    else
                        currentTheme("material.blue.light");
                    refreshTheme();
                    this.fazVerificacaoCores()
                }
            },
            msgSistema(newVal, oldVal) {
                if (!newVal)
                    return;
                //console.log('msgSistema:',newVal, oldVal);
                try {
                    sessionStorage.setItem('msgSistema', newVal);
                } catch {}
                this.msg_SistemaReset();
                this.$vistra.exibeMensagemSistema();
            },
            isLoggedIn(newVal) {
                if (!newVal)
                    this.$vistra.SignalRUsuariosConectados.close()
            },
            "$store.getters.idioma"(newVal) {
                locale(newVal)
            },
            '$route.path': {
                handler(newVal) {
                    this.setTema();
                }
            }
        },
        beforeCreate() {
            this.$vistra.carregaTraducao([traducaoGeral, traducaoPaises, traducaoMenu]);
            const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/;
            JSON.dateParser = function (key, value) {
                if (typeof value === "string" && dateFormat.test(value)) {
                    return new Date(value);
                }
                return value;
            }
        },
        async created() {
            EVENTS.forEach((event) =>
                window.addEventListener(event, this.updateOnlineStatus),
            )
            //usado pra guardar recentes
            window.IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction;
            window.IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange;

            this.carregouEmpresas = false;

            if (this.isLoggedIn) {

                await this.$vistra.carregaMoeda();
                await this.$vistra.carregaEmpresas();
                this.carregouEmpresas = true;
            } 
            else 
                this.carregouEmpresas = true;

            if (this.isLoggedIn && this.idEmpresa) {
                this.$vistra.SignalRUsuariosConectados.onDerrubarUsuario = this.onDerrubarUsuario
                this.$vistra.SignalRUsuariosConectados.onStatusChanged = this.setSignalRStatus
                this.$vistra.SignalRUsuariosConectados.start()
            }
            setInterval(() => {
                // serve pra todas as abas abertas irem pra tela de login quando o usuário não estiver mais logado
                let estavaLogado = this.isLoggedIn
                this.atualizaState()
                if (estavaLogado && !this.isLoggedIn)
                    this.$router.push({name: 'login'})
            }, 5000)
        },
        mounted() {
            this.$vistra.exibeMensagemSistema();
            this.$vistra.carregaInfoSistema();
            this.$vistra.carregaInfoReport();
            this.$vistra.carregaInfoVistraIA();
            this.$vistra.getConfiguracoesGeralServicos()
            this.setTema();
            this.fazVerificacaoCores()
            this.$vistra.carregaLinkChangeLogs();
        },
        beforeUnmount() {
            this.$vistra.SignalRUsuariosConectados.close()
            EVENTS.forEach((event) =>
                window.removeEventListener(event, this.updateOnlineStatus),
            )
        },
        methods: {
            ...mapMutations(['msg_SistemaReset', 'setSistema']),
            ...mapActions(['setOnlineStatus', 'setSignalRStatus', 'atualizaState']),
            dispatchEventClosePopups(e) {
                EventClosePopups = new CustomEvent('ClosePopups', {detail: e})
                document.dispatchEvent(EventClosePopups);
            },
            onDerrubarUsuario(idUsuario, msg) {
                console.log("======>>>>> desconectando forçadamente ")
                if (!idUsuario || (this.usuario?.id.toUpperCase() == idUsuario.toUpperCase())) {
                    this.logout()
                    if (msg)
                        this.$vistra.showMessage(msg)
                    else
                        this.$vistra.showMessage(this.$vistra.globalize('msg-desconectado-por-usuario-administrador'), 'error')
                }
            },
            ...mapActions(['temaVistra']),
            fazVerificacaoCores() {
                setTimeout(() => this.verificaCores = Math.random(), 10)    
                setTimeout(() => this.verificaCores = Math.random(), 500)    
            },
            setaTemaLogin(){
                const html = document.querySelector("html");
                if (html) {
                    if (!html.classList.contains("dark"))
                        html.classList.add("dark");
                    this.carregouTema = true;
                }
                this.fazVerificacaoCores()
            },
            updateOnlineStatus() {

                //o código acima estava sendo bloqueado em um cliente por chamar url do google e foi removido
                this.setOnlineStatus(navigator.onLine);
            },
            async setTema() {
                
                await this.$nextTick();
                let _this = this;
                let telasLogin = (this.$route.path == '/login' || this.$route.path.startsWith('/resetarSenha/') || this.$route.path.startsWith('/recuperarSenha'))
                
                if (telasLogin) {
                    this.temaVistra(true)
                    this.setaTemaLogin();
                } else {
                    _this.$vistra.Objetos.when(() => _this.usuario,
                    () => {
                        let usuarioNovo = this.usuario?.modoEscuro === undefined ? true : false;
                        let tema = _this.tema === 'tema-dark' ? true : false;
                        
                        // Definir o valor do tema com base nas condições
                        let novoTema = tema || usuarioNovo;

                        this.temaVistra(novoTema);
                        //_this.carregouTema = true;
                    });
                }
                document.getElementsByTagName('body')[0].style.visibility = 'visible';
            },
            logout() {
                this.$router.push({name: 'login'});
            }
        }
    };

    var $buoop = {required:{e:-4,f:-3,o:-3,s:-1,c:-3},insecure:true,api:2019.08 }; 
    function $buo_f(){ 
        var e = document.createElement("script"); 
        e.src = "//browser-update.org/update.min.js"; 
        document.body.appendChild(e);
    };
    try {document.addEventListener("DOMContentLoaded", $buo_f,false)}
    catch(e){window.attachEvent("onload", $buo_f)}
</script>

<style lang="scss">
    #app {
        display: flex;
        height: 100vh;
        width: 100vw;
        .page-container-ux {
            margin: 0 auto !important;
            padding: 0px;
            // TODO VERIFICAR QUANDO FOR FAZER MERGE E DEIXAR COMO TA NA 542
                margin-top: 35px !important;
            // TODO TAREFA #110162
            max-width: 1538px !important;
        }

        .page {
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            display: flex;
            flex-direction: column;
        }
        .dx-scrollable-content {
            padding-right: 0px !important;
            // @apply bg-white dark:bg-gray-800 #{!important};
        }

        #area-de-popups {
            @import "@/styles/base.scss";
            width: 100vw;
            height: 100vh;
            position: absolute;
        }
    }
    
    .dx-scrollable-content {
        padding-bottom: 0px !important;
    }
    .dx-scrollable-content {
        padding-bottom: 0px !important;
    }

    /* font awesome */
    .fa-rotate-45 {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    /* bootstrap */
    .card {
        background-color: unset !important;
    }

    /*devextreme*/
    .dx-tab-content > .dx-icon {
        display: block !important;
    }
    
    .formulario {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }
</style>

<style lang="scss">
    #app .dx-toolbar:not(.menu-float):not(#menu-superior-painel-execucao):not(.dx-htmleditor-toolbar):not(div[class*=dx-popup]):not(.gridSeletorConsultaSqlReduced) .dx-toolbar-items-container {
        height: var(--altura-barra-superior);
    }   
    [v-cloak] > * { display:none }
    [v-cloak]::before { content: "…" }

    .clarear-background-05 {
        background: rgba(255, 255, 255, .05);
    }
    .clarear-background-10 {
        background: rgba(255, 255, 255, .1);
    }

    .clarear-background-20 {
        background: rgba(255, 255, 255, .2);
    }

    .clarear-background-30 {
        background: rgba(255, 255, 255, .3);
    }

    .clarear-background-40 {
        background: rgba(255, 255, 255, .4);
    }

    .clarear-background-50 {
        background: rgba(255, 255, 255, .5);
    }

    .clarear-background-60 {
        background: rgba(255, 255, 255, .6);
    }

    ////////////////////

    .escurecer-background-05 {
        background: rgba(0, 0, 0, .05);
    }

    .escurecer-background-10 {
        background: rgba(0, 0, 0, .1);
    }

    .escurecer-background-20 {
        background: rgba(0, 0, 0, .2);
    }

    .escurecer-background-30 {
        background: rgba(0, 0, 0, .3);
    }

    .escurecer-background-40 {
        background: rgba(0, 0, 0, .4);
    }

    .escurecer-background-50 {
        background: rgba(0, 0, 0, .5);
    }

    .escurecer-background-60 {
        background: rgba(0, 0, 0, .6);
    }

    ////////////////////

    .no-wrap {
        white-space: nowrap;
        word-break: keep-all;
    }

    .wrap {
        white-space: initial;
        word-break: initial;
    }

    //desabilita seleção
    .no-selection {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
    }

    .dx-field-item-label-location-top {
        padding: 4px 0px 2px !important;
    }
</style>